import { Box3, Object3D, Vector3 } from 'three';
import { ProjectRenderer } from '../ProjectRenderer';
import { Measurement } from './Measurement';
import { MeasurementOffsetAxis } from '../types';
import { RenderUtils } from '../utils/RenderUtils';
import RENDERER_CONFIG from '@/configs/rendererConfig';

const { ID, LABEL_OFFSET, LABEL_ROTATION } =
	RENDERER_CONFIG.MEASUREMENT.TOTAL_HEIGHT;

export class TotalHeightMeasurement extends Measurement {
	private box = new Box3();
	private meshBox = new Box3();

	constructor(renderer: ProjectRenderer) {
		super(renderer, {
			id: ID,
			label: ID,
			offsetAxis: MeasurementOffsetAxis.X,
			offsetLength: -RENDERER_CONFIG.MEASUREMENT.OFFSET,
			labelOffset: new Vector3(...LABEL_OFFSET),
			labelRotation: LABEL_ROTATION,
			points: [new Object3D(), new Object3D()],
		});

		this.draw();
	}

	private updatePoints() {
		const model = this.renderer.handleManager.model;
		if (!model) return;

		model.updateWorldMatrix(true, true);
		this.box.makeEmpty();

		model.traverseVisible((object) => {
			if (!RenderUtils.isMesh(object) || !object.geometry) return;

			if (!object.geometry.boundingBox) object.geometry.computeBoundingBox();

			this.meshBox
				.copy(object.geometry.boundingBox!)
				.applyMatrix4(object.matrixWorld);
			this.box.union(this.meshBox);
		});

		if (this.box.isEmpty()) return;

		const [start, end] = this.points;
		const centerZ = (this.box.min.z + this.box.max.z) / 2;

		start.position.set(this.box.min.x, this.box.min.y, centerZ);
		end.position.set(this.box.min.x, this.box.max.y, centerZ);
	}

	protected override getLabelValue() {
		return Math.round(
			this.renderer.handleManager.adjustableHeights.total * 1000
		);
	}

	override draw() {
		this.updatePoints();
		super.draw();
	}
}
